import {
  FormControlDependsOnSchema,
  CreateDependsOnFactory,
  FormControlDependsOnThenEnum
} from "@cak-legacy/generation-core";
import { INestedDependsOn, IDependsOn } from "../../client/model/dependsOn";
import { AbstractDependsOnMapper } from "./AbstractDependsOnMapper";

export class DefaultDependsOnMapper extends AbstractDependsOnMapper {
  constructor(
    private readonly type:
      | FormControlDependsOnThenEnum.Disable
      | FormControlDependsOnThenEnum.Hide
      | FormControlDependsOnThenEnum.IsRequired
      | FormControlDependsOnThenEnum.SetFocus
  ) {
    super();
  }
  convertNested(item: INestedDependsOn, _fieldType: string): FormControlDependsOnSchema<any> {
    return CreateDependsOnFactory.create({
      ...this.getBaseNestedProperties(item),
      then: this.type
    });
  }

  convert(item: IDependsOn, _fieldType: string): FormControlDependsOnSchema<never[]> {
    const result = CreateDependsOnFactory.create({
      ...this.getBaseProperties(item),
      then: this.type
    });

    return result;
  }
}
